// tabs
// CONCATENATED MODULE: ./src/components/tabs.js
function tabs_toConsumableArray(arr) {
  return (
    tabs_arrayWithoutHoles(arr) ||
    tabs_iterableToArray(arr) ||
    tabs_unsupportedIterableToArray(arr) ||
    tabs_nonIterableSpread()
  );
}
function tabs_nonIterableSpread() {
  throw new TypeError(
    "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
  );
}
function tabs_unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return tabs_arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return tabs_arrayLikeToArray(o, minLen);
}
function tabs_iterableToArray(iter) {
  if (
    (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null) ||
    iter["@@iterator"] != null
  )
    return Array.from(iter);
}
function tabs_arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return tabs_arrayLikeToArray(arr);
}
function tabs_arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function tabs_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    (enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols));
  }
  return keys;
}
function tabs_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? tabs_ownKeys(Object(source), !0).forEach(function (key) {
          tabs_defineProperty(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(
            target,
            Object.getOwnPropertyDescriptors(source),
          )
        : tabs_ownKeys(Object(source)).forEach(function (key) {
            Object.defineProperty(
              target,
              key,
              Object.getOwnPropertyDescriptor(source, key),
            );
          });
  }
  return target;
}
function tabs_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function tabs_classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function tabs_defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function tabs_createClass(Constructor, protoProps, staticProps) {
  if (protoProps) tabs_defineProperties(Constructor.prototype, protoProps);
  if (staticProps) tabs_defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var tabs_Default = {
  defaultTabId: null,
  activeClasses: "#000000",
  inactiveClasses: "#B0B0B0",
  onShow: function onShow() {},
};
var Tabs = /*#__PURE__*/ (function () {
  function Tabs() {
    var items =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    tabs_classCallCheck(this, Tabs);
    this._items = items;
    this._activeTab = options ? this.getTab(options.defaultTabId) : null;
    this._options = tabs_objectSpread(
      tabs_objectSpread({}, tabs_Default),
      options,
    );
    this._init();
  }
  tabs_createClass(Tabs, [
    {
      key: "_init",
      value: function _init() {
        var _this = this;
        if (this._items.length) {
          // set the first tab as active if not set by explicitly
          if (!this._activeTab) {
            this._setActiveTab(this._items[0]);
          } // force show the first default tab
          this.show(this._activeTab.id, true); // show tab content based on click
          this._items.map(function (tab) {
            tab.triggerEl.addEventListener("click", function () {
              _this.show(tab.id);
              // refreshslider add
            });
          });
        }
      },
    },
    {
      key: "getActiveTab",
      value: function getActiveTab() {
        return this._activeTab;
      },
    },
    {
      key: "_setActiveTab",
      value: function _setActiveTab(tab) {
        this._activeTab = tab;
      },
    },
    {
      key: "getTab",
      value: function getTab(id) {
        return this._items.filter(function (t) {
          return t.id === id;
        })[0];
      },
    },
    {
      key: "show",
      value: function show(id) {
        var _this2 = this,
          _tab$triggerEl$classL,
          _tab$triggerEl$classL2;
        var forceShow =
          arguments.length > 1 && arguments[1] !== undefined
            ? arguments[1]
            : false;
        var tab = this.getTab(id); // don't do anything if already active
        if (tab === this._activeTab && !forceShow) {
          return;
        } // hide other tabs
        this._items.map(function (t) {
          if (t !== tab) {
            var _t$triggerEl$classLis, _t$triggerEl$classLis2;
            (_t$triggerEl$classLis = t.triggerEl.classList).remove.apply(
              _t$triggerEl$classLis,
              tabs_toConsumableArray(_this2._options.activeClasses.split(" ")),
            );
            (_t$triggerEl$classLis2 = t.triggerEl.classList).add.apply(
              _t$triggerEl$classLis2,
              tabs_toConsumableArray(
                _this2._options.inactiveClasses.split(" "),
              ),
            );
            t.targetEl.classList.add("hidden");
            t.triggerEl.setAttribute("aria-selected", false);
          }
        }); // show active tab
        (_tab$triggerEl$classL = tab.triggerEl.classList).add.apply(
          _tab$triggerEl$classL,
          tabs_toConsumableArray(this._options.activeClasses.split(" ")),
        );
        (_tab$triggerEl$classL2 = tab.triggerEl.classList).remove.apply(
          _tab$triggerEl$classL2,
          tabs_toConsumableArray(this._options.inactiveClasses.split(" ")),
        );
        tab.triggerEl.setAttribute("aria-selected", true);
        tab.targetEl.classList.remove("hidden");
        this._setActiveTab(tab); // callback function
        this._options.onShow(this, tab);
      },
    },
  ]);
  return Tabs;
})();
window.Tabs = Tabs;
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-tabs-toggle]").forEach(function (triggerEl) {
    var tabElements = [];
    var defaultTabId = null;
    triggerEl.querySelectorAll('[role="tab"]').forEach(function (el) {
      var isActive = el.getAttribute("aria-selected") === "true";
      var tab = {
        id: el.getAttribute("data-tabs-target"),
        triggerEl: el,
        targetEl: document.querySelector(el.getAttribute("data-tabs-target")),
      };
      tabElements.push(tab);
      if (isActive) {
        defaultTabId = tab.id;
      }
    });
    new Tabs(tabElements, {
      defaultTabId: defaultTabId,
    });
  });
});
/* harmony default export */ const tabs = Tabs;
// tabs
// accordion
// UNUSED EXPORTS: default
// CONCATENATED MODULE: ./src/components/accordion.js
function _toConsumableArray(arr) {
  return (
    _arrayWithoutHoles(arr) ||
    _iterableToArray(arr) ||
    _unsupportedIterableToArray(arr) ||
    _nonIterableSpread()
  );
}
function _nonIterableSpread() {
  throw new TypeError(
    "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
  );
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (
    (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null) ||
    iter["@@iterator"] != null
  )
    return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    (enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols));
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? ownKeys(Object(source), !0).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(
            target,
            Object.getOwnPropertyDescriptors(source),
          )
        : ownKeys(Object(source)).forEach(function (key) {
            Object.defineProperty(
              target,
              key,
              Object.getOwnPropertyDescriptor(source, key),
            );
          });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var Default = {
  alwaysOpen: false,
  activeClasses: "activated flex flex-row justify-between items-center",
  inactiveClasses: "w-full",
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onToggle: function onToggle() {},
};
var Accordion = /*#__PURE__*/ (function () {
  function Accordion() {
    var items =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Accordion);
    this._items = items;
    this._options = _objectSpread(_objectSpread({}, Default), options);
    this._init();
  }
  _createClass(Accordion, [
    {
      key: "_init",
      value: function _init() {
        var _this = this;
        if (this._items.length) {
          // show accordion item based on click
          this._items.map(function (item) {
            if (item.active) {
              _this.open(item.id);
            }
            item.triggerEl.addEventListener("click", function () {
              _this.toggle(item.id);
            });
          });
        }
      },
    },
    {
      key: "getItem",
      value: function getItem(id) {
        return this._items.filter(function (item) {
          return item.id === id;
        })[0];
      },
    },
    {
      key: "open",
      value: function open(id) {
        var _this2 = this,
          _item$triggerEl$class,
          _item$triggerEl$class2;
        var item = this.getItem(id); // don't hide other accordions if always open
        if (!this._options.alwaysOpen) {
          this._items.map(function (i) {
            if (i !== item) {
              var _i$triggerEl$classLis, _i$triggerEl$classLis2;
              (_i$triggerEl$classLis = i.triggerEl.classList).remove.apply(
                _i$triggerEl$classLis,
                _toConsumableArray(_this2._options.activeClasses.split(" ")),
              );
              (_i$triggerEl$classLis2 = i.triggerEl.classList).add.apply(
                _i$triggerEl$classLis2,
                _toConsumableArray(_this2._options.inactiveClasses.split(" ")),
              );
              i.targetEl.classList.add("hidden");
              i.triggerEl.setAttribute("aria-expanded", false);
              i.active = false;
              // remove rotate from image
              var closeImage = i.triggerEl.querySelector("img");
              if (closeImage) {
                closeImage.classList.remove("rotate-180");
              }
            }
          });
        }
        // show active item
        (_item$triggerEl$class = item.triggerEl.classList).add.apply(
          _item$triggerEl$class,
          _toConsumableArray(this._options.activeClasses.split(" ")),
        );
        (_item$triggerEl$class2 = item.triggerEl.classList).remove.apply(
          _item$triggerEl$class2,
          _toConsumableArray(this._options.inactiveClasses.split(" ")),
        );
        item.triggerEl.setAttribute("aria-expanded", true);
        item.targetEl.classList.remove("hidden");
        item.active = true;
        // add rotate to image
        var openImage = item.triggerEl.querySelector("img");
        if (openImage) {
          openImage.classList.add("rotate-180");
        }
        // callback function
        this._options.onOpen(this, item);
      },
    },
    {
      key: "toggle",
      value: function toggle(id) {
        var item = this.getItem(id);
        if (item.active) {
          this.close(id);
        } else {
          this.open(id);
        } // callback function
        this._options.onToggle(this, item);
      },
    },
    {
      key: "close",
      value: function close(id) {
        var _item$triggerEl$class3, _item$triggerEl$class4;
        var item = this.getItem(id);
        (_item$triggerEl$class3 = item.triggerEl.classList).remove.apply(
          _item$triggerEl$class3,
          _toConsumableArray(this._options.activeClasses.split(" ")),
        );
        (_item$triggerEl$class4 = item.triggerEl.classList).add.apply(
          _item$triggerEl$class4,
          _toConsumableArray(this._options.inactiveClasses.split(" ")),
        );
        item.targetEl.classList.add("hidden");
        item.triggerEl.setAttribute("aria-expanded", false);
        item.active = false;
        // remove rotate from image
        var closeImage = item.triggerEl.querySelector("img");
        if (closeImage) {
          closeImage.classList.remove("rotate-180");
        }
        // callback function
        this._options.onClose(this, item);
      },
    },
  ]);
  return Accordion;
})();
window.Accordion = Accordion;
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-accordion]").forEach(function (accordionEl) {
    var alwaysOpen = accordionEl.getAttribute("data-accordion");
    var activeClasses = accordionEl.getAttribute("data-active-classes");
    var inactiveClasses = accordionEl.getAttribute("data-inactive-classes");
    var items = [];
    accordionEl
      .querySelectorAll("[data-accordion-target]")
      .forEach(function (el) {
        var item = {
          id: el.getAttribute("data-accordion-target"),
          triggerEl: el,
          targetEl: document.querySelector(
            el.getAttribute("data-accordion-target"),
          ),
          iconEl: el.querySelector("[data-accordion-icon]"),
          active: el.getAttribute("aria-expanded") === "true" ? true : false,
        };
        items.push(item);
      });
    new Accordion(items, {
      alwaysOpen: alwaysOpen === "open" ? true : false,
      activeClasses: activeClasses ? activeClasses : Default.activeClasses,
      inactiveClasses: inactiveClasses
        ? inactiveClasses
        : Default.inactiveClasses,
    });
  });
});
/* harmony default export */ const accordion = Accordion; // CONCATENATED MODULE: ./src/components/collapse.js
function collapse_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    (enumerableOnly &&
      (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })),
      keys.push.apply(keys, symbols));
  }
  return keys;
}
function collapse_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2
      ? collapse_ownKeys(Object(source), !0).forEach(function (key) {
          collapse_defineProperty(target, key, source[key]);
        })
      : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(
            target,
            Object.getOwnPropertyDescriptors(source),
          )
        : collapse_ownKeys(Object(source)).forEach(function (key) {
            Object.defineProperty(
              target,
              key,
              Object.getOwnPropertyDescriptor(source, key),
            );
          });
  }
  return target;
}
function collapse_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function collapse_classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function collapse_defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function collapse_createClass(Constructor, protoProps, staticProps) {
  if (protoProps) collapse_defineProperties(Constructor.prototype, protoProps);
  if (staticProps) collapse_defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var collapse_Default = {
  triggerEl: null,
  onCollapse: function onCollapse() {},
  onExpand: function onExpand() {},
  onToggle: function onToggle() {},
};
var Collapse = /*#__PURE__*/ (function () {
  function Collapse() {
    var targetEl =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var options = arguments.length > 1 ? arguments[1] : undefined;
    collapse_classCallCheck(this, Collapse);
    this._targetEl = targetEl;
    this._triggerEl = options ? options.triggerEl : collapse_Default.triggerEl;
    this._options = collapse_objectSpread(
      collapse_objectSpread({}, collapse_Default),
      options,
    );
    this._visible = false;
    this._init();
  }
  collapse_createClass(Collapse, [
    {
      key: "_init",
      value: function _init() {
        var _this = this;
        if (this._triggerEl) {
          if (this._triggerEl.hasAttribute("aria-expanded")) {
            this._visible =
              this._triggerEl.getAttribute("aria-expanded") === "true"
                ? true
                : false;
          } else {
            // fix until v2 not to break previous single collapses which became dismiss
            this._visible = this._targetEl.classList.contains("hidden")
              ? false
              : true;
          }
          this._triggerEl.addEventListener("click", function () {
            _this._visible ? _this.collapse() : _this.expand();
          });
        }
      },
    },
    {
      key: "collapse",
      value: function collapse() {
        this._targetEl.classList.add("hidden");
        if (this._triggerEl) {
          this._triggerEl.setAttribute("aria-expanded", "false");
        }
        this._visible = false; // callback function
        this._options.onCollapse(this);
      },
    },
    {
      key: "expand",
      value: function expand() {
        this._targetEl.classList.remove("hidden");
        if (this._triggerEl) {
          this._triggerEl.setAttribute("aria-expanded", "true");
        }
        this._visible = true; // callback function
        this._options.onExpand(this);
      },
    },
    {
      key: "toggle",
      value: function toggle() {
        if (this._visible) {
          this.collapse();
        } else {
          this.expand();
        }
      },
    },
  ]);
  return Collapse;
})();
window.Collapse = Collapse;
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll("[data-collapse-toggle]")
    .forEach(function (triggerEl) {
      var targetEl = document.getElementById(
        triggerEl.getAttribute("data-collapse-toggle"),
      );
      new Collapse(targetEl, {
        triggerEl: triggerEl,
      });
    });
});
/* harmony default export */ const collapse = Collapse;
// accordion
// Function to set responsive width and height attributes for images with lazy loading and auto-filled alt text
window.addEventListener("DOMContentLoaded", (event) => {
  // Select all <a> and <button> elements on the page
  const anchors = document.querySelectorAll("a");
  const buttons = document.querySelectorAll("button");
  // Function to set aria-label for <a> elements
  anchors.forEach((a) => {
    // Check if aria-label is missing
    if (!a.hasAttribute("aria-label")) {
      // If the anchor has text content, use that as aria-label
      if (a.textContent.trim() !== "") {
        a.setAttribute("aria-label", a.textContent.trim());
      } else {
        // If the anchor has no text, you can use the href value as aria-label or fallback to a default label
        const hrefValue = a.getAttribute("href") || "Link";
        a.setAttribute("aria-label", `Link to ${hrefValue}`);
      }
    }
  });
  // Function to set aria-label for <button> elements
  buttons.forEach((button) => {
    // Check if aria-label is missing
    if (!button.hasAttribute("aria-label")) {
      // If the button has text content, use that as aria-label
      if (button.textContent.trim() !== "") {
        button.setAttribute("aria-label", button.textContent.trim());
      } else {
        // Fallback if the button has no text content
        button.setAttribute("aria-label", "Button");
      }
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".tab-button");
  const tabContents = document.querySelectorAll(".tab-content");
  // Set first tab as active by default
  if (tabButtons.length > 0 && tabContents.length > 0) {
    tabButtons[0].classList.add("active");
    tabContents[0].classList.remove("hidden");
  }
  // Add click listener to each tab button
  tabButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const targetContent = document.querySelector(
        this.getAttribute("data-tab-target"),
      );
      // Hide all contents
      tabContents.forEach((content) => {
        content.classList.add("hidden");
      });
      // Remove active state from all buttons
      tabButtons.forEach((btn) => {
        btn.classList.remove("active");
      });
      // Show the selected tab and mark button as active
      if (targetContent) {
        targetContent.classList.remove("hidden");
        this.classList.add("active");
      }
    });
  });
});
// Drawer Toggle Logic
const cartDrawer = document.getElementById("cartDrawer");
const openBtns = document.querySelectorAll(".openCartBtn");
const closeBtn = document.getElementById("addToCartClose");

// Initial safety: Agar page load par drawer khula nahi hai, to clicks disable rakhein
if (cartDrawer && !window.location.search.includes('cart_open=true')) {
    cartDrawer.style.pointerEvents = "none";
    cartDrawer.style.opacity = "0";
}

function openDrawer() {
  if (cartDrawer) {
    cartDrawer.style.opacity = "1";
    cartDrawer.style.pointerEvents = "auto"; // Clicks enable karein
    cartDrawer.classList.remove("translate-x-[100%]");
  }
}

function closeDrawer() {
  if (cartDrawer) {
    cartDrawer.classList.add("translate-x-[100%]");
    cartDrawer.style.pointerEvents = "none"; // Clicks disable karein (Taki piche click ho sakay)
    setTimeout(() => {
      cartDrawer.style.opacity = "0";
    }, 300);
  }
}

// Drawer Auto-Open Logic (Reload ke baad wala)
document.addEventListener('DOMContentLoaded', function() {
  const urlParams = new URLSearchParams(window.location.search);
  
  if (urlParams.get('cart_open') === 'true') {
    if (cartDrawer) {
      // Wahi UI behaviour jo openDrawer function ka hai
      cartDrawer.style.opacity = "1";
      cartDrawer.style.pointerEvents = "auto"; 
      cartDrawer.style.transform = "translateX(0%)";
      cartDrawer.classList.remove("translate-x-[100%]");
      cartDrawer.classList.add('active'); 

      // URL Cleanup
      setTimeout(() => {
        window.history.replaceState({}, document.title, window.location.pathname);
      }, 1000);
    }
  }
});

// Event Listeners
if (openBtns.length > 0) {
  openBtns.forEach((btn) => btn.addEventListener("click", openDrawer));
}
if (closeBtn) {
  closeBtn.addEventListener("click", closeDrawer);
}

// Shopify AJAX Update Quantity
function updateQuantity(id, qty) {
  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ quantity: qty, id: id }),
  })
    .then((response) => response.json())
    .then((data) => {
      refreshCartDrawer();
    })
    .catch((error) => console.error("Error:", error));
}

// Refresh Cart UI
function refreshCartDrawer() {
  window.location.reload();
}
// Mobile Menu Toggle
const mobileHam = document.getElementById("mobile-hamburger");
const mobileMenu = document.getElementById("mobile-menu");
const mobileClose = document.getElementById("mobile-close");
if (mobileHam && mobileMenu) {
  mobileHam.addEventListener("click", () => {
    mobileMenu.classList.remove("right-[-100%]");
    mobileMenu.classList.add("right-0");
    if (mobileClose) mobileClose.classList.remove("hidden");
  });
}
if (mobileClose && mobileMenu) {
  mobileClose.addEventListener("click", () => {
    mobileMenu.classList.add("right-[-100%]");
    mobileMenu.classList.remove("right-0");
  });
}
// Mobile Dropdown Accordion
document.querySelectorAll(".mobile-toggle").forEach((btn) => {
  btn.addEventListener("click", function () {
    const dropdown = this.nextElementSibling;
    if (dropdown) {
      dropdown.classList.toggle("hidden");
      const span = this.querySelector("span");
      if (span) {
        span.innerText = dropdown.classList.contains("hidden") ? "+" : "-";
      }
    }
  });
});
// Categories carousel
const owlCategories = $(".owl-categories");
if (owlCategories.length) {
  owlCategories.owlCarousel({
    loop: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2000,
    autoplayTimeout: 2000,
    smartSpeed: 2000,
    margin: 20,
    slideTransition: "linear",
    center: false,
    responsive: {
      0: { items: 1 },
      400: { items: 2 },
      640: { items: 3 },
      768: { items: 4 },
      1024: { items: 5 },
    },
  });
}
document.addEventListener("DOMContentLoaded", () => {
  const countItems = document.querySelectorAll(".counter");
  const startCounter = (el) => {
    const target = parseInt(el.getAttribute("data-counter"));
    let count = 0;
    const speed = 2000; // Animation kitni der chale (2 seconds)
    const increment = target / (speed / 16); // 60fps ke hisab se calculation
    const updateCount = () => {
      count += increment;
      if (count < target) {
        el.innerText = Math.ceil(count);
        requestAnimationFrame(updateCount);
      } else {
        el.innerText = target;
      }
    };
    updateCount();
  };
  const observerOptions = {
    threshold: 0.5, // Jab 50% section nazar aaye tab chalay
  };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Jab section screen par aaye
        startCounter(entry.target);
      } else {
        // Jab section screen se bahar jaye, number wapas 0 kar dein
        // taake dobara aane par phir se animation chale
        entry.target.innerText = "0";
      }
    });
  }, observerOptions);
  countItems.forEach((item) => {
    observer.observe(item);
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const video = document.getElementById("ctaVideo");
  const playBtn = document.getElementById("playBtnContainer");
  if (video && playBtn) {
    playBtn.addEventListener("click", function () {
      if (video.paused) {
        video.play();
        playBtn.style.opacity = "0";
        playBtn.style.pointerEvents = "none";
      }
    });
    // Video par click karne se pause/play toggle
    video.addEventListener("click", function () {
      if (video.paused) {
        video.play();
        playBtn.style.opacity = "0";
      } else {
        video.pause();
        playBtn.style.opacity = "1";
        playBtn.style.pointerEvents = "auto";
      }
    });
  }
});
// Products carousel
const owlProducts = $(".owl-products");
if (owlProducts.length) {
  owlProducts.owlCarousel({
    nav: false,
    dots: true,
    loop: true,
    autoplay: true,
    margin: 10,
    center: false,
    responsive: {
      0: { items: 1 },
      400: { items: 2 },
      640: { items: 3 },
      768: { items: 4 },
      1024: { items: 5 },
    },
  });
  // Custom nav buttons
  $("#productsprevBtn").click(function () {
    owlProducts.trigger("prev.owl.carousel");
  });
  $("#productsnextBtn").click(function () {
    owlProducts.trigger("next.owl.carousel");
  });
}
$(document).ready(function () {
  // Check if any scrollTopBtn exists on the page
  if (document.querySelector(".scrollTopBtn")) {
    document.addEventListener("click", function (e) {
      const btn = e.target.closest(".scrollTopBtn");
      if (!btn) return;
      e.preventDefault();
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("CollectionSearch");
  const sortSelect = document.getElementById("CollectionSort");
  const grid = document.getElementById("CollectionGrid");
  const cards = Array.from(document.querySelectorAll(".collection-card"));
  const noResults = document.getElementById("NoResults");
  // --- AJAX Search Logic (Live Filtering) ---
  if (searchInput) {
    // Check if searchInput exists
    searchInput.addEventListener("input", function (e) {
      const searchTerm = e.target.value.toLowerCase();
      let visibleCount = 0;
      cards.forEach((card) => {
        const title = card.getAttribute("data-title");
        if (title && title.includes(searchTerm)) {
          card.style.display = "block";
          visibleCount++;
        } else {
          card.style.display = "none";
        }
      });
      if (noResults) noResults.classList.toggle("hidden", visibleCount > 0);
    });
  }
  // --- Sorting Logic ---
  if (sortSelect && grid) {
    // Check if sortSelect and grid exist
    sortSelect.addEventListener("change", function (e) {
      const value = e.target.value;
      let sortedCards = [...cards];
      if (value === "az") {
        sortedCards.sort((a, b) =>
          (a.getAttribute("data-title") || "").localeCompare(
            b.getAttribute("data-title") || "",
          ),
        );
      } else if (value === "za") {
        sortedCards.sort((a, b) =>
          (b.getAttribute("data-title") || "").localeCompare(
            a.getAttribute("data-title") || "",
          ),
        );
      } else if (value === "new") {
        sortedCards.sort(
          (a, b) => b.getAttribute("data-date") - a.getAttribute("data-date"),
        );
      } else if (value === "old") {
        sortedCards.sort(
          (a, b) => a.getAttribute("data-date") - b.getAttribute("data-date"),
        );
      }
      // Re-append sorted cards to grid
      grid.innerHTML = "";
      sortedCards.forEach((card) => grid.appendChild(card));
    });
  }
});
document.addEventListener("submit", (e) => {
  // Check if the form is an Add to Cart form
  if (e.target.matches('form[action="/cart/add"]')) {
    e.preventDefault(); // Redirect rokne ke liye
    const formData = new FormData(e.target);
    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((item) => {
        // Refresh se pehle storage mein save karo ke drawer kholna hai
        localStorage.setItem("open_cart_drawer", "true");
        // Page refresh (Jaisa aapne manga tha)
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error adding to cart:", error);
      });
  }
});
document.addEventListener("DOMContentLoaded", () => {
  // --- AUTO-OPEN DRAWER AFTER REFRESH ---
  if (localStorage.getItem("open_cart_drawer") === "true") {
    // 1. Dawn Theme style trigger
    const cartDrawer = document.querySelector("cart-drawer");
    const cartNotification = document.querySelector("cart-notification");
    if (cartDrawer) {
      cartDrawer.classList.add("active");
      // Shopify Dawn internal method to open drawer
      if (typeof cartDrawer.open === "function") cartDrawer.open();
    } else if (cartNotification) {
      // Dawn notification style
      if (typeof cartNotification.show === "function") cartNotification.show();
    } else {
      // 2. Generic Theme Trigger (Cart Icon click simulate karna)
      // Ye un themes ke liye hai jo class ya id use karti hain
      const cartToggle =
        document.querySelector("#cart-icon-bubble") ||
        document.querySelector(".header__icon--cart") ||
        document.querySelector(".cart-toggle") ||
        document.querySelector("[data-cart-drawer-toggle]");
      if (cartToggle) cartToggle.click();
    }
    // Kaam khatam hone ke baad storage clear kar do
    localStorage.removeItem("open_cart_drawer");
  }
  // --- VARIABLES ---
  const sortSelect = document.getElementById("AjaxSort");
  const searchInput = document.getElementById("ProductSearch");
  // --- LIVE SEARCH LOGIC ---
  // --- LIVE SEARCH LOGIC ---
  searchInput?.addEventListener("input", (e) => {
    const term = e.target.value.toLowerCase();
    const cards = document.querySelectorAll(".product-card");
    const NoResultsProduct = document.getElementById("NoResultsProduct"); // Div ko select kiya
    let hasVisibleCards = false; // Check karne ke liye variable

    cards.forEach((card) => {
      const title = card.getAttribute("data-title") || "";
      if (title.includes(term)) {
        card.style.display = "block";
        hasVisibleCards = true; // Agar ek bhi card mila toh true
      } else {
        card.style.display = "none";
      }
    });

    // Agar hasVisibleCards false hai, toh "hidden" class hata do (show kardo)
    if (NoResultsProduct) {
      if (hasVisibleCards) {
        NoResultsProduct.classList.add("hidden");
      } else {
        NoResultsProduct.classList.remove("hidden");
      }
    }
  });
  // --- AJAX GRID UPDATE (Sort/Pagination) ---
  const updateGrid = (url) => {
    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const gridContainer = document.getElementById("ProductGridContainer");
        const newContent = doc.getElementById("ProductGridContainer");
        if (gridContainer && newContent) {
          gridContainer.innerHTML = newContent.innerHTML;
        }
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
  };
  // --- SORT LISTENER ---
  sortSelect?.addEventListener("change", (e) => {
    const url = new URL(window.location.href);
    url.searchParams.set("sort_by", e.target.value);
    window.history.pushState({}, "", url);
    updateGrid(url.href);
  });
  // --- PAGINATION LISTENER ---
  document.addEventListener("click", (e) => {
    if (e.target.classList.contains("pagination-link")) {
      e.preventDefault();
      const url = e.target.href;
      window.history.pushState({}, "", url);
      updateGrid(url);
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  
  // Function to update cart via Shopify API
  async function updateCart(key, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    window.location.reload(); // Re-fetch updated liquid values
  }

  // Handle Plus/Minus Buttons
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const input = e.target.closest('div').querySelector('.qty-input');
      let currentVal = parseInt(input.value);
      const key = e.target.dataset.key;

      if (e.target.classList.contains('plus')) {
        updateCart(key, currentVal + 1);
      } else if (e.target.classList.contains('minus') && currentVal > 0) {
        updateCart(key, currentVal - 1);
      }
    });
  });

  // Handle Remove (Cross) Click
  document.querySelectorAll('.remove-item').forEach(cross => {
    cross.addEventListener('click', (e) => {
      e.preventDefault();
      const key = e.target.dataset.key;
      updateCart(key, 0); // Quantity 0 means remove
    });
  });

  // Handle direct input change
  document.querySelectorAll('.qty-input').forEach(input => {
    input.addEventListener('change', (e) => {
      updateCart(e.target.dataset.key, e.target.value);
    });
  });
});

function validateQty(direction) {
  const input = document.getElementById('QuantityInput');
  const errorMsg = document.getElementById('QtyError');
  const buyNowBtn = document.getElementById('BuyNowBtn');
  
  // Shopify se current variant ki inventory aur ID lein
  const maxStock = parseInt(input.getAttribute('max')) || 999;
  const variantId = '{{ product.selected_or_first_available_variant.id }}';
  
  let currentVal = parseInt(input.value);

  if (direction === 'up') {
    if (currentVal < maxStock) {
      input.value = currentVal + 1;
      errorMsg.classList.add('hidden');
    } else {
      errorMsg.classList.remove('hidden');
    }
  } else if (direction === 'down') {
    if (currentVal > 1) {
      input.value = currentVal - 1;
      errorMsg.classList.add('hidden');
    }
  }
  
  // Buy Now link update karein taake sahi quantity checkout pe jaye
  if(buyNowBtn) {
    buyNowBtn.href = `/cart/${variantId}:${input.value}`;
  }
}

document.addEventListener('DOMContentLoaded', function () {
  
  const form = document.querySelector('form[action="/cart/add"]');
  if (!form) return; // agar form nahi mila to script stop
  
  const btn = document.getElementById('AddToCartBtn');
  if (!btn) return; // agar button nahi mila to script stop

  form.addEventListener('submit', function (e) {
    if (btn.disabled) {
      e.preventDefault();
    }
  });

});
document.addEventListener('click', function(e) {
  // Check karein ke click hamare button par hua hai
  const btn = e.target.closest('#AddToCartBtn');
  
  if (btn) {
    e.preventDefault();
    
    // 1. Variant ID aur Quantity nikalna
    let variantId = btn.getAttribute('data-variant-id');
    const qtyInput = document.getElementById('QuantityInput');
    let quantity = qtyInput ? qtyInput.value : 1;

    // Agar button mein ID nahi mili, to form dhoondo
    if (!variantId) {
       const form = btn.closest('form');
       if (form) {
         const idInput = form.querySelector('[name="id"]');
         variantId = idInput ? idInput.value : null;
       }
    }

    if (!variantId) {
      alert("Error: Product Variant ID not found!");
      return;
    }

    // 2. Loading State (Button UI)
    const originalText = btn.innerHTML;
    btn.innerHTML = 'Adding...';
    btn.disabled = true;

    // 3. AJAX Call to Shopify Cart
    let formData = {
      'items': [{
        'id': variantId,
        'quantity': quantity
      }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (!response.ok) throw new Error('Out of stock or error');
      return response.json();
    })
    .then(item => {
      btn.innerHTML = 'Added!';
      
      // 4. Page Reload Logic (Redirect nahi hoga, sirf wahi page refresh hoga)
      // Hum URL mein ?cart_open=true bhejenge taake refresh ke baad drawer khule
      let currentUrl = window.location.origin + window.location.pathname;
      window.location.href = currentUrl + '?cart_open=true';
    })
    .catch(error => {
      console.error('Final Error:', error);
      btn.innerHTML = 'Error!';
      btn.disabled = false;
      setTimeout(() => { btn.innerHTML = originalText; }, 2000);
    });
  }
});

document.addEventListener('click', function(e) {
  // 1. Plus Button Logic
  if (e.target.closest('.plus')) {
    const btn = e.target.closest('.plus');
    const container = btn.parentElement;
    const input = container.querySelector('.qty-input');
    const key = btn.getAttribute('data-key');
    const errorMsg = document.getElementById('error-' + key);
    
    const maxStock = parseInt(input.getAttribute('max')) || 999;
    let currentVal = parseInt(input.value);

    if (currentVal < maxStock) {
      input.value = currentVal + 1;
      if (errorMsg) errorMsg.classList.add('hidden'); // Hide error if value is valid
      
      if (typeof updateQuantity === "function") {
        updateQuantity(key, input.value);
      }
    } else {
      // Alert ki jagah paragraph show karna
      if (errorMsg) {
        errorMsg.classList.remove('hidden');
        // 3 second baad automatic hide karne ke liye (Optional)
        setTimeout(() => {
          errorMsg.classList.add('hidden');
        }, 3000);
      }
    }
  }

  // 2. Minus Button Logic
  if (e.target.closest('.minus')) {
    const btn = e.target.closest('.minus');
    const container = btn.parentElement;
    const input = container.querySelector('.qty-input');
    const key = btn.getAttribute('data-key');
    const errorMsg = document.getElementById('error-' + key);
    
    let currentVal = parseInt(input.value);

    if (currentVal > 0) {
      input.value = currentVal - 1;
      if (errorMsg) errorMsg.classList.add('hidden'); // Hide error when decreasing
      
      if (typeof updateQuantity === "function") {
        updateQuantity(key, input.value);
      }
    }
  }
});
(function () {

  function optimizeImages(scope = document) {
    const images = scope.querySelectorAll("img");

    images.forEach(img => {

      // Skip if already processed
      if (img.dataset.optimized) return;

      function applyAttributes() {

        // 1️⃣ Width & Height set only if missing
        if (!img.getAttribute("width") && img.naturalWidth) {
          img.setAttribute("width", img.naturalWidth);
        }

        if (!img.getAttribute("height") && img.naturalHeight) {
          img.setAttribute("height", img.naturalHeight);
        }

        // 2️⃣ Alt attribute auto-generate if missing
        if (!img.getAttribute("alt") || img.getAttribute("alt") === "") {
          let fileName = img.src.split('/').pop().split('.')[0];
          fileName = fileName.replace(/[-_]/g, " ");
          img.setAttribute("alt", fileName || "Website Image");
        }

        // Mark as processed
        img.dataset.optimized = "true";
      }

      // If image already loaded
      if (img.complete) {
        applyAttributes();
      } else {
        img.addEventListener("load", applyAttributes);
      }

    });
  }

  // Run on initial load
  document.addEventListener("DOMContentLoaded", function () {
    optimizeImages();
  });

  // MutationObserver for dynamic content (Owl Carousel etc.)
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          optimizeImages(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();